import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import MobileNav from "@/components/MobileNav";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen bg-app flex items-center justify-center">
        <div className="font-mono text-buy tracking-widest text-sm">LOADING...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return (
    <>
      {children}
      <MobileNav user={user} />
    </>
  );
}
